var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 12.6668C2.66665 13.6668 2.66665 11.0001 1.33331 10.6668M10.6666 14.6668V12.0868C10.6917 11.7689 10.6487 11.4493 10.5407 11.1493C10.4326 10.8493 10.2619 10.5757 10.04 10.3468C12.1333 10.1135 14.3333 9.32012 14.3333 5.68012C14.3331 4.74934 13.9751 3.85425 13.3333 3.18012C13.6372 2.36579 13.6157 1.46569 13.2733 0.666788C13.2733 0.666788 12.4866 0.433455 10.6666 1.65345C9.13865 1.23934 7.52797 1.23934 5.99998 1.65345C4.17998 0.433455 3.39331 0.666788 3.39331 0.666788C3.0509 1.46569 3.02941 2.36579 3.33331 3.18012C2.68673 3.85925 2.32833 4.76243 2.33331 5.70012C2.33331 9.31345 4.53331 10.1068 6.62665 10.3668C6.40731 10.5934 6.23816 10.8637 6.13019 11.1601C6.02222 11.4564 5.97785 11.7722 5.99998 12.0868V14.6668",
    stroke: "#95A8C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.7b35cc9192d36e6fb2db8dfa7b207e4a.svg";
export { ForwardRef as ReactComponent };